import { render } from "./PeachLocale.vue?vue&type=template&id=0a2a7019"
import script from "./PeachLocale.vue?vue&type=script&lang=js"
export * from "./PeachLocale.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__